import CoveragePackageModalLink from '../../CoveragePackageModalLink';
import { SelectField } from '@flos/react-ui';
import { useHippoText } from '../../../../../hooks/useHippoText';
import type { ChangeEvent } from 'react';
import { useUpdateCoveragePackageInformation } from '../../../../../recoil/hooks/useUpdateCoveragePackageInformation';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { deductibleOptionsSelector } from '../../../../../recoil/selectors/deductibleOptionsSelector';
import { useUpdateCoverableInformation } from '../../../../../recoil/hooks/useUpdateCoverableInformation';
import { allCoverablesOnsaAtom } from '../../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCoverable } from '../../../../../utils/coverablesUtil';
import type {
    PrhHolidayHomeOnsaDTO,
    PrhHouseOnsaDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/house';
import { refreshCoveragePackagePricesAtom } from '../../../../../recoil/atoms/refreshCoveragePackagePricesAtom';

const HouseInputDeductible = ({
    isLoading,
    setIsLoading
}: {
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const inputHeaderText = getHippoText('DSS-COVERAGE-PACKAGE-PAGE-DEDUCTIBLE-HEADER');
    const modalName = getHippoText('DSS-COVERAGE-PACKAGE-PAGE-INPUT-INFO');
    const refreshPrices = useSetRecoilState(refreshCoveragePackagePricesAtom);
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const { updateCoveragePackageInformation } = useUpdateCoveragePackageInformation<
        PrhHouseOnsaDTO | PrhHolidayHomeOnsaDTO
    >();
    const { flavourName = '', fixedId = '' } = useRecoilValue(getOnsaCurrentProductSelector);
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId) as
        | PrhHouseOnsaDTO
        | PrhHolidayHomeOnsaDTO;
    const deductibleOptions = useRecoilValue(deductibleOptionsSelector('PRHFireCov'));

    const changeDeductible = (event: ChangeEvent<HTMLSelectElement>): void => {
        if (event.target.value) {
            setIsLoading(true);
            updateCoverableInformation({ fireCovDeductible: event.target.value });
            void updateCoveragePackageInformation({
                fireCovDeductible: event.target.value
            }).then(() => {
                refreshPrices({});
                setIsLoading(false);
            });
        }
    };

    return (
        <>
            <div className="u-flex-box u-flex-box--space-between">
                <h4>{inputHeaderText}</h4>
                <CoveragePackageModalLink
                    modalName={modalName}
                    title={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-DEDUCTIBLE-INFO-MODAL-TITLE')}
                    description={getHippoText(
                        'DSS-COVERAGE-PACKAGE-PAGE-DEDUCTIBLE-INFO-MODAL-DESCRIPTION'
                    )}
                />
            </div>
            <div className="u-spacing-stack-none">
                <SelectField
                    placeholder={coverable.fireCovDeductible}
                    label={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-DEDUCTIBLE-FIELD-TEXT')}
                    onChange={changeDeductible}
                    options={deductibleOptions.map((option) => {
                        return { label: option.displayName, value: option.optionID };
                    })}
                    value={coverable.fireCovDeductible}
                    disabled={isLoading}
                ></SelectField>
            </div>
        </>
    );
};

export default HouseInputDeductible;
